import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import notFoundImg from "assets/images/not-found.png";
import { useEffect, useState } from "react";
import MDTypography from "./MDTypography";

function ImagePreviewModal({
    images = [],
    comments = [],
    index = 0,
    src,
    alt = "Image",
    open,
    onClose,
    enableNavigation = false,
    onPrev,
    onNext,
}) {
    const [failed, setFailed] = useState(false);
    useEffect(() => {
        if (open) setFailed(false);
    }, [src, open]);

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    borderRadius: 2,
                    p: 2,
                    pt: 3,
                    maxWidth: 550,
                    minWidth: 400,
                    outline: "none",
                }}
            >
                <IconButton
                    sx={{ position: "absolute", top: 0, right: 3, zIndex: 2 }}
                    onClick={onClose}
                    size="large"
                >
                    <CloseIcon />
                </IconButton>
                {/* Flex row: arrows - image - arrows */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 2,
                        mb: 2,
                    }}
                >
                    {enableNavigation && images.length > 1 && (
                        <IconButton
                            onClick={onPrev}
                            disabled={index <= 0}
                            size="large"
                        >
                            <ChevronLeft />
                        </IconButton>
                    )}
                    <Box
                        component="img"
                        src={failed
                            ? notFoundImg
                            : enableNavigation
                                ? images[index] || notFoundImg
                                : src || notFoundImg}
                        alt={alt}
                        onError={() => setFailed(true)}
                        sx={{
                            minHeight: 300,
                            maxHeight: 600,
                            maxWidth: 500,
                            objectFit: "contain",
                            borderRadius: 2,
                            boxShadow: 1,
                        }}
                    />
                    {enableNavigation && images.length > 1 && (
                        <IconButton
                            onClick={onNext}
                            disabled={index >= images.length - 1}
                            size="large"
                        >
                            <ChevronRight />
                        </IconButton>
                    )}
                </Box>
                <MDTypography variant="body2" sx={{ textAlign: "center", mt: 1 }}>
                    {comments[index] ?? ""}
                </MDTypography>
            </Box>
        </Modal>
    );
}

export default ImagePreviewModal;
